import { ResultsDialogComponent } from './../results-dialog/results-dialog.component';
import { BuildPlayersService } from './../../shared/services/build-players.service';
import { ScoreValues } from './../../shared/models/score-values';
import { Component, OnInit, ApplicationRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TeeType } from 'src/app/shared/models/tee-type';
import { GolfCoursesService } from 'src/app/shared/services/golf-courses.service';
import * as _ from 'lodash';
import { CourseData } from 'src/app/shared/models/course-data';
import { Players } from 'src/app/shared/models/players';
import { DupeNamePipe } from 'src/app/shared/pipes/dupe-name.pipe';
import { MatDialogConfig, MatDialog } from '@angular/material';

@Component({
  selector: 'app-score-card',
  templateUrl: './score-card.component.html',
  styleUrls: ['./score-card.component.css'],
  providers: [DupeNamePipe]
})
export class ScoreCardComponent implements OnInit {
  teeBoxes;
  selectedTeeType: TeeType;
  teeTypes: TeeType[];
  courseInfo: CourseData;
  players: Players;

  constructor(
    private route: ActivatedRoute,
    private golfCourseService: GolfCoursesService,
    private buildPlayersService: BuildPlayersService,
    public dialog: MatDialog
  ) {

  }

  ngOnInit() {
    _.isEmpty({});
    const id = + this.route.snapshot.paramMap.get('id');
    this.golfCourseService.getCourse(id)
      .subscribe(course => {
        this.teeTypes = this.decorateCourse(course).teeTypes;
        this.selectedTeeType = this.teeTypes[0];
      });
    this.players = this.buildPlayersService.buildPlayers();
  }

  decorateCourse(data: any): CourseData {

    const newData = _(data.holes).map((h) => {
      return _.map(h.teeBoxes, (tb) => _.merge(tb, { hole: h.hole }));
    }).flatMap().groupBy('teeType').map((t) => {
      return {
        name: t[0].teeType,
        hole: _.map(t, 'hole'),
        par: _.map(t, 'par'),
        yards: _.map(t, 'yards'),
        hcp: _.map(t, 'hcp')
      };
    }).value();

    const courseData: CourseData = { name: data.name, teeTypes: [] };
    let i = 0;
    newData.forEach((d: any) => {
      const tt = new TeeType();
      tt.name = d.name;
      tt.scoreValues = [];

      const svH = new ScoreValues();
      svH.name = 'Holes';
      svH.order = i++;
      svH.values = d.hole;
      tt.scoreValues.push(svH);

      const svY = new ScoreValues();
      svY.name = 'Yards';
      svY.order = i++;
      svY.values = d.yards;
      tt.scoreValues.push(svY);

      const svP = new ScoreValues();
      svP.name = 'Par';
      svP.order = i++;
      svP.values = d.par;
      tt.scoreValues.push(svP);

      const svHc = new ScoreValues();
      svHc.name = 'Handicap';
      svHc.order = i++;
      svHc.values = d.hcp;
      tt.scoreValues.push(svHc);

      courseData.teeTypes.push(tt);
    });

    this.courseInfo = courseData;
    return courseData;
  }

  toggleTodo(value) {
    this.selectedTeeType = value;
  }

  getResults() {
    let parTotal: number;
    this.selectedTeeType.scoreValues.forEach((p) => {
      if (p.name === 'Par') {
        parTotal = p.sumIn + p.sumOut;
      }
    });
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      players: this.players,
      par: parTotal,
      courseName: this.courseInfo.name
    };

    const dialogRef = this.dialog.open(ResultsDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      console.log('Dialog was closed');
      console.log(result);
    });
  }
}
